<template>
  <div class="w-full flex flex-col gap-2">
    <label
      class="text-[#121212] font-semibold text-[16px] leading-[24px] flex items-center gap-1"
      style="font-family: 'Open Sans'"
    >
      {{ label }}
      <span
        v-if="required"
        class="text-[#E25C5C] font-[500] text-[16px] leading-[24px]"
        >*</span
      >
    </label>
    <vue-tel-input
      v-model="phoneValue"
      :mode="'international'"
      :default-country="defaultCountry"
      :valid-characters-only="true"
      :preferred-countries="['us', 'ca', 'gb']"
      :input-options="{ showDialCode: true }"
      :placeholder="'+1 (000) 000-0000'"
      class="custom-tel-input border border-[#CCCCCC] rounded-[8px] flex items-center px-3"
      @validate="onValidate"
      @country-changed="onCountryChanged"
      @blur="onBlur"
    />
    <p v-if="errorMessage" class="text-red-500 text-[14px]">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

const props = defineProps({
  label: String,
  modelValue: String,
  errorMessage: String,
  required: { type: Boolean, default: false },
  defaultCountry: { type: String, default: 'us' }
});

const emit = defineEmits(["update:modelValue", "validate", "country-changed", "blur"]);

// Create a local ref for the phone value
const phoneValue = ref(props.modelValue || "");

// Watch for changes in the local value and emit update events
watch(phoneValue, (newValue) => {
  emit("update:modelValue", newValue);
});

// Watch for changes in the prop value and update local ref
watch(() => props.modelValue, (newValue) => {
  if (newValue !== phoneValue.value) {
    phoneValue.value = newValue;
  }
});

const isValid = ref(false);
const country = ref(null);

const onValidate = (validation) => {
  isValid.value = validation.valid;
  emit('validate', { 
    valid: validation.valid, 
    country: country.value 
  });
};

const onCountryChanged = (newCountry) => {
  country.value = newCountry;
  emit('country-changed', newCountry);
};

const onBlur = () => {
  emit('blur');
};
</script>

<style>
/* Customize Vue-Tel-Input Styles */

.custom-tel-input:focus-within {
  box-shadow: none !important;
}
.custom-tel-input .vti__input {
  width: 100%;
  height: 46px;
  border-left: 1px solid #e5e7eb;
  background: transparent;
  font-family: "Open Sans";
  outline: none;
}
</style>
